import { AwardRef } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const getEligibleAwardRefs: (
  fetchContext: FetchContext,
  accessToken?: string,
) => Promise<AwardRef[]> = (fetchContext, accessToken) => fetch(`${fetchContext.baseUrl}/api/eligible-award-refs`,
  {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<AwardRef[]>(fetchContext.errorStore, response, 'get eligible award refs'));
